/**
 * Small progressive enhancements.
 *
 * Forms marked [data-nb-autosubmit] submit as soon as a select changes, so the
 * collection sort works in one interaction. The matching <noscript> button in
 * the markup covers the case where this never runs.
 */
(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-nb-autosubmit]').forEach((form) => {
      if (form.dataset.nbBound === '1') return;
      form.dataset.nbBound = '1';

      form.addEventListener('change', (event) => {
        if (event.target.matches('select, input[type="radio"], input[type="checkbox"]')) {
          form.submit();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
